import React from 'react';
import { Outlet, useLocation, Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useIaJobs } from '../context/IaJobsProvider';
import { LudiBottomNav } from '../components/ludi';
import LudiBetaBanner from '../components/ludi/LudiBetaBanner';
import { ROUTES_WITHOUT_NAV } from '../config/navItems';
import LudiIaJobBar from '../components/LudiIaJobBar';
import IaFeedbackReviewHost from '../components/IaFeedbackReviewHost';
import IaOnboardingReviewHost from '../components/IaOnboardingReviewHost';
import WorkoutWizardHost from '../components/WorkoutWizardHost';

const AUTH_PATHS = ['/login', '/start', '/register', '/terms', '/privacy', '/reset-password'];
const AUTH_PREFIX = '/register/';

function isAuthPage(pathname) {
  if (pathname === '/') return false;
  if (AUTH_PATHS.includes(pathname)) return true;
  if (pathname.startsWith(AUTH_PREFIX)) return true;
  return false;
}

export default function AppShell({ children }) {
  const { isAuthenticated } = useAuth();
  const { hasIaBarActivity } = useIaJobs();
  const location = useLocation();
  const pathname = location.pathname;

  const showNav =
    isAuthenticated &&
    !isAuthPage(pathname) &&
    !ROUTES_WITHOUT_NAV.includes(pathname);

  const showIaBar = isAuthenticated && !isAuthPage(pathname);
  const showIaHosts =
    isAuthenticated && !isAuthPage(pathname) && pathname !== '/session';

  const showBetaBanner = pathname !== '/' && !hasIaBarActivity;

  return (
    <div className="min-h-screen bg-ludi-bg text-ludi-t100 flex flex-col font-ludi">
      {showBetaBanner && <LudiBetaBanner />}
      {showIaBar && <LudiIaJobBar />}
      {showIaHosts && (
        <>
          <IaFeedbackReviewHost />
          <IaOnboardingReviewHost />
          <WorkoutWizardHost />
        </>
      )}
      <main
        className={`flex-1 mx-auto w-full max-w-app px-ludi-4 py-ludi-4 ${showNav ? 'pb-safe-nav' : ''}`}
        style={{ paddingTop: hasIaBarActivity ? 'calc(var(--ludi-ia-bar-h, 0px) + 1rem)' : undefined }}
      >
        {children || <Outlet />}
      </main>
      {showNav && <LudiBottomNav />}
    </div>
  );
}

export function RootRedirect() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  if (isAuthenticated) return <Navigate to="/home" replace />;
  return null;
}
